import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
const Page403 = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/dashboard');
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle="Xin lỗi, bạn không có quyền truy cập vào trang này. Hãy thử liên hệ với quản trị viên để được hỗ trợ."
      extra={
        <Button type="primary" onClick={handleNavigate}>
          Quay lại trang chủ
        </Button>
      }
    />
  );
};
export default Page403;
